import useSWR from "swr";

import { api } from 'api';
import useUser from "hooks/useUser";

function usePlayerStats(playerId) {

    const { userData } = useUser();

    const fetcher = async () => {
        const response = await api.player.getPlayerStats(playerId);
        return response.data;
    }

    // Conditional key: SWR skips fetching without a playerId, and the endpoint
    // needs a token, so skip it for logged out users rather than take a 403.
    const { data, error, isLoading, mutate } = useSWR(
        playerId && userData ? `player-stats/${playerId}` : null,
        fetcher
    );

    return {
        player: data?.player || null,
        stats: data?.stats || null,
        recentResults: data?.recentResults || null,
        playerStatsError: error,
        playerStatsLoading: isLoading,
        mutatePlayerStats: mutate,
    }
}

export default usePlayerStats;
